import { HTMLAttributes } from "react";

type HourglassFilledProps = HTMLAttributes<SVGElement> & {
  size?: string;
  color?: string;
};

export const HourglassFilled = ({
  size = "20",
  color = "#4E68F6",
  ...props
}: HourglassFilledProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.4585 1.875C16.9187 1.875 17.2918 2.2481 17.2918 2.70833C17.2918 3.16857 16.9187 3.54167 16.4585 3.54167H16.0418V4.33675C16.0418 5.51924 15.5316 6.63988 14.6511 7.40885L14.4704 7.55697L11.321 10L14.4704 12.443L14.6511 12.5912C15.5316 13.3602 16.0418 14.4807 16.0418 15.6632V16.4583H16.4585C16.9187 16.4583 17.2918 16.8314 17.2918 17.2917C17.2918 17.7519 16.9187 18.125 16.4585 18.125H3.54183C3.0816 18.125 2.7085 17.7519 2.7085 17.2917C2.7085 16.8314 3.0816 16.4583 3.54183 16.4583H3.9585V15.6632C3.9585 14.4022 4.53905 13.2121 5.52995 12.443L8.67858 10L5.52995 7.55697C4.53905 6.78794 3.9585 5.59783 3.9585 4.33675V3.54167H3.54183C3.0816 3.54167 2.7085 3.16857 2.7085 2.70833C2.7085 2.2481 3.0816 1.875 3.54183 1.875H16.4585ZM5.56982 3.54167V4.33675C5.56982 5.09352 5.91832 5.80812 6.51302 6.26953L10.0002 8.97458L13.4873 6.26953L13.5963 6.1792C14.1244 5.71782 14.4305 5.04603 14.4305 4.33675V3.54167H5.56982Z"
        fill={color}
      />
    </svg>
  );
};
